import React from 'react'

import { Login } from '../components/Auth/Login'
import { UnauthenticatedLayout } from '../layouts/Unauthenticated.layout'

export const LoginPage: React.FC = () => {
    return (
        <UnauthenticatedLayout>
            <Login />
        </UnauthenticatedLayout>
    )
}
